import Router from './routes/router'
import './App.css';
import { Toaster } from 'react-hot-toast';
import muiVariables from './styles/mui-variables';
import { I18nextProvider } from 'react-i18next';
import i18n from './translation/translations';

function App() {
  return (
    <>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          className: "",
          style: {
            fontFamily: muiVariables.mainFontFamily,
            fontSize: "auto",
            backgroundColor: `${muiVariables.avatarBgColor}`,
          },
        }}
        containerStyle={{
          top: 30,
          bottom: 20,
          right: 30,
        }}
      />
    </>
  );
}

export default App;
